export const facebook = {
    namespaced: true,
    state: {
        showAside: false,
        configuration: {
            form: null,
            account: null,
            page: null
        }
    },
    getters: {
        getStatusAside: state => state.showAside,
        getConfigurationForm: state => state.configuration.form,
        getConfigurationAccount: state => state.configuration.account,
        getConfigurationPage: state => state.configuration.page
    },
    mutations: {
        SET_STATUS_ASIDE(state, payload) {
            state.showAside = payload
        },
        SET_CONFIGURATION_FORM(state, payload) {
            state.configuration.form = { ...payload }
        },
        SET_CONFIGURATION_ACCOUNT(state, payload) {
            state.configuration.account = { ...payload }
        },
        SET_CONFIGURATION_PAGE(state, payload) {
            state.configuration.page = { ...payload }
        }
    },
    actions: {
        setStatusAside({ commit }, payload) {
            commit('SET_STATUS_ASIDE', payload)
        },
        /**
         * Seta no state o formulário selecionado para configuração 
         */
        setConfigurationForm({ commit }, payload) {
            commit('SET_CONFIGURATION_FORM', payload)
        },
        /**
         * Seta no state a conta de Facebook selecionada para configuração de formulário
         */
        setConfigurationAccount({ commit }, payload) {
            commit('SET_CONFIGURATION_ACCOUNT', payload)
        },
        /**
         * Seta no state a página do facebook selecionada para configuração de formulário
         */
        setConfigurationPage({ commit }, payload) {
            commit('SET_CONFIGURATION_PAGE', payload)
        }
    }
}
